import {
    ActionStatusStreamAction,
    ActionStatusStreamStatus,
    type ActionBubble,
    type Conversation,
    type Message,
} from "@repo/guide-types";

/**
 * Update the conversation to indicate an error.
 *
 * @param conversation The conversation to be modified.
 * @returns The updated conversation where an incoming error message is
 * appended.
 */
export const appendConversationWithErrorMessage = (
    conversation: Conversation,
    message: string,
    actionBubbles?: ActionBubble[],
): Conversation => {
    const lastMessage = conversation[conversation.length - 1];

    // If the last message is marked as an interim message (
    // isGeneratingResponse = true), then it is a message that should be
    // replaced with the error message.
    const errorMessage: Message = {
        type: "incoming",
        text: message,
        user: "Teacher",
        uiOnly: true,
        serverOnly: false,
        interactionId: "",
        isError: true,
        actionBubbles,
    };

    // In case the last message in the conversation was in the middle of
    // generating a response before erroring out, we mark those flags false.
    if (lastMessage?.isGeneratingResponse) {
        const newActionStatusMap = new Map(lastMessage.actionStatusMap);
        newActionStatusMap.set(
            ActionStatusStreamAction.TEXT,
            ActionStatusStreamStatus.ERROR,
        );
        return [
            ...conversation.slice(0, -1),
            {
                ...lastMessage,
                isGeneratingResponse: false,
                actionStatusMap: newActionStatusMap,
            },
            errorMessage,
        ];
    }

    return [...conversation, errorMessage];
};
